'use client';

import { darkTheme, getDefaultConfig } from '@rainbow-me/rainbowkit';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { FC } from 'react';
import { http } from 'viem';
import {
  arbitrum,
  arbitrumSepolia,
  avalanche,
  avalancheFuji,
  base,
  baseSepolia,
  blast,
  blastSepolia,
  bsc,
  bscTestnet,
  linea,
  lineaSepolia,
  mainnet,
  mantle,
  optimism,
  optimismSepolia,
  polygon,
  polygonMumbai,
  scroll,
  scrollSepolia,
  sepolia,
  zkSync,
  zkSyncSepoliaTestnet,
  zora,
  zoraSepolia,
} from 'viem/chains';
import { WagmiProvider } from 'wagmi';

const projectId = process.env.NEXT_PUBLIC_CONNECT_WALLET_PROJECT_ID!;

const config = getDefaultConfig({
  appName: 'Formo',
  projectId,
  chains: [
    mainnet,
    sepolia,
    arbitrum,
    arbitrumSepolia,
    avalanche,
    avalancheFuji,
    base,
    baseSepolia,
    blast,
    blastSepolia,
    bsc,
    bscTestnet,
    linea,
    lineaSepolia,
    mantle,
    optimism,
    optimismSepolia,
    polygon,
    polygonMumbai,
    scroll,
    scrollSepolia,
    zkSync,
    zkSyncSepoliaTestnet,
    zora,
    zoraSepolia,
  ],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
    [arbitrum.id]: http(),
    [arbitrumSepolia.id]: http(),
    [avalanche.id]: http(),
    [avalancheFuji.id]: http(),
    [base.id]: http(),
    [baseSepolia.id]: http(),
    [blast.id]: http(),
    [blastSepolia.id]: http(),
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
    [linea.id]: http(),
    [lineaSepolia.id]: http(),
    [mantle.id]: http(),
    [optimism.id]: http(),
    [optimismSepolia.id]: http(),
    [polygon.id]: http(),
    [polygonMumbai.id]: http(),
    [scroll.id]: http(),
    [scrollSepolia.id]: http(),
    [zkSync.id]: http(),
    [zkSyncSepoliaTestnet.id]: http(),
    [zora.id]: http(),
    [zoraSepolia.id]: http(),
  },
});

const queryClient = new QueryClient();

type Web3ModalProviderProps = {
  children: React.ReactNode;
};

const Web3ModalProvider: FC<Web3ModalProviderProps> = ({ children }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={darkTheme()} modalSize="compact">
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default Web3ModalProvider;
